(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (() => {
    const pad = (value) => String(Math.max(0, value)).padStart(2, '0');

    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-countdown]').forEach((countdown) => {
        if (countdown.dataset.initialized === 'true') return;
        const end = Date.parse(countdown.dataset.countdownEnd || '');
        if (Number.isNaN(end)) return;

        countdown.dataset.initialized = 'true';
        const hours = countdown.querySelector('[data-countdown-hours]');
        const minutes = countdown.querySelector('[data-countdown-minutes]');
        const seconds = countdown.querySelector('[data-countdown-seconds]');

        const update = () => {
          const remaining = Math.max(0, end - Date.now());
          const totalSeconds = Math.floor(remaining / 1000);
          if (hours) hours.textContent = pad(Math.floor(totalSeconds / 3600));
          if (minutes) minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
          if (seconds) seconds.textContent = pad(totalSeconds % 60);
          if (remaining === 0) window.clearInterval(countdown.countdownTimer);
        };

        update();
        countdown.countdownTimer = window.setInterval(update, 1000);
      });
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rs-featured-reviews]').forEach((section) => {
    const button = section.querySelector('[data-rs-reviews-more]');
    if (!button) return;
    button.addEventListener('click', () => {
      const expanded = section.dataset.expanded === 'true';
      section.dataset.expanded = expanded ? 'false' : 'true';
      button.textContent = expanded ? 'Read More Reviews' : 'Read Less Reviews';
      button.setAttribute('aria-expanded', String(!expanded));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-resilia-faithful"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeMosaicRails = (root = document) => {
      root.querySelectorAll('.tsh-mosaic__right[data-drag-scroll]:not([data-drag-ready])').forEach((rail) => {
        rail.dataset.dragReady = 'true';

        let activePointer = null;
        let startX = 0;
        let startScrollLeft = 0;
        let hasDragged = false;
        let suppressNextClick = false;

        const finishDrag = (event) => {
          if (activePointer === null || event.pointerId !== activePointer) return;

          if (rail.hasPointerCapture(activePointer)) {
            rail.releasePointerCapture(activePointer);
          }

          rail.classList.remove('is-dragging');
          activePointer = null;

          if (hasDragged) {
            const cards = Array.from(rail.children);
            const nearestCard = cards.reduce((nearest, card) => {
              if (!nearest) return card;
              return Math.abs(card.offsetLeft - rail.scrollLeft) <
                Math.abs(nearest.offsetLeft - rail.scrollLeft)
                ? card
                : nearest;
            }, null);

            if (nearestCard) {
              rail.scrollTo({ left: nearestCard.offsetLeft, behavior: 'smooth' });
            }

            suppressNextClick = true;
            window.setTimeout(() => {
              suppressNextClick = false;
            }, 0);
          }
        };

        rail.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;

          activePointer = event.pointerId;
          startX = event.clientX;
          startScrollLeft = rail.scrollLeft;
          hasDragged = false;
          rail.classList.add('is-dragging');
          rail.setPointerCapture(activePointer);
        });

        rail.addEventListener('pointermove', (event) => {
          if (activePointer === null || event.pointerId !== activePointer) return;

          const distance = event.clientX - startX;
          if (Math.abs(distance) > 5) {
            hasDragged = true;
            event.preventDefault();
          }

          rail.scrollLeft = startScrollLeft - distance;
        });

        rail.addEventListener('pointerup', finishDrag);
        rail.addEventListener('pointercancel', finishDrag);

        rail.addEventListener(
          'click',
          (event) => {
            if (!suppressNextClick) return;
            event.preventDefault();
            event.stopPropagation();
            suppressNextClick = false;
          },
          true
        );
      });
    };

    initializeMosaicRails();
    document.addEventListener('shopify:section:load', (event) => initializeMosaicRails(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredient-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (section) => {
      if (!section || section.dataset.ingredientsInitialized === 'true') return;
      section.dataset.ingredientsInitialized = 'true';
      const track = section.querySelector('[data-rs-ingredients-track]');
      const cards = [...section.querySelectorAll('[data-rs-ingredient-card]')];
      const previous = section.querySelector('[data-rs-ingredients-prev]');
      const next = section.querySelector('[data-rs-ingredients-next]');
      if (!track || !cards.length || !previous || !next) return;
      let activeIndex = 0;
      let dragPointerId = null;
      let dragStartX = 0;
      let dragStartScrollLeft = 0;
      let hasDragged = false;
      let hasInteracted = false;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const positionFor = (card) => card.offsetLeft - cards[0].offsetLeft;
      const closestIndex = () => cards.reduce((closest, card, index) => (
        Math.abs(positionFor(card) - track.scrollLeft) < Math.abs(positionFor(cards[closest]) - track.scrollLeft)
          ? index
          : closest
      ), 0);

      const show = (index, behavior = prefersReducedMotion.matches ? 'auto' : 'smooth') => {
        activeIndex = index < 0 ? cards.length - 1 : index >= cards.length ? 0 : index;
        track.scrollTo({ left: positionFor(cards[activeIndex]), behavior });
      };

      previous.addEventListener('click', () => show(activeIndex - 1));
      next.addEventListener('click', () => show(activeIndex + 1));
      track.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        show(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
      });
      track.addEventListener('scroll', () => {
        activeIndex = closestIndex();
      }, { passive: true });

      track.addEventListener('pointerdown', (event) => {
        hasInteracted = true;
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragPointerId = event.pointerId;
        dragStartX = event.clientX;
        dragStartScrollLeft = track.scrollLeft;
        hasDragged = false;
        track.setPointerCapture(event.pointerId);
        track.classList.add('is-dragging');
      });

      track.addEventListener('pointermove', (event) => {
        if (event.pointerId !== dragPointerId) return;
        const distance = event.clientX - dragStartX;
        if (Math.abs(distance) > 4) hasDragged = true;
        track.scrollLeft = dragStartScrollLeft - distance;
      });

      const finishDrag = (event) => {
        if (event.pointerId !== dragPointerId) return;
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
        dragPointerId = null;
        track.classList.remove('is-dragging');
        if (hasDragged) activeIndex = closestIndex();
      };

      track.addEventListener('pointerup', finishDrag);
      track.addEventListener('pointercancel', finishDrag);
      track.addEventListener('lostpointercapture', (event) => {
        if (event.pointerId !== dragPointerId) return;
        dragPointerId = null;
        track.classList.remove('is-dragging');
        if (hasDragged) activeIndex = closestIndex();
      });

      const resetToFirst = () => {
        activeIndex = 0;
        track.scrollTo({ left: 0, behavior: 'auto' });
      };

      resetToFirst();
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (!hasInteracted) resetToFirst();
      }));

      if (cards.length < 2) section.querySelector('.rs-ingredients__nav')?.setAttribute('hidden', '');
    };

    document.querySelectorAll('[data-rs-ingredients]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-rs-ingredients]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-cart-page] [data-quantity-change]').forEach((button) => {
      if (button.dataset.initialized === 'true') return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', () => {
        const input = button.closest('[data-quantity-input]')?.querySelector('input');
        if (!input) return;
        const minimum = Number(input.min || 0);
        const maximum = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;
        input.value = Math.min(maximum, Math.max(minimum, Number(input.value || 0) + Number(button.dataset.quantityChange)));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-sort-select]').forEach((select) => {
      if (select.dataset.initialized === 'true') return;
      select.dataset.initialized = 'true';
      select.addEventListener('change', () => select.form?.submit());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const form = root.querySelector('[data-main-product-form]');
      const variantCards = [...root.querySelectorAll('[data-variant-card]')];
      const addButton = root.querySelector('[data-add-to-cart]');
      const addText = root.querySelector('[data-add-to-cart-text]');
      const status = root.querySelector('[data-product-form-status]');
      const currentPrices = [...root.querySelectorAll('[data-current-price], [data-atc-price]')];
      const comparePrices = [...root.querySelectorAll('[data-compare-price], [data-atc-compare]')];
      const saleBadge = root.querySelector('[data-sale-badge]');
      const soldOutBadge = root.querySelector('[data-sold-out-badge]');
      const subscriptionInfo = root.querySelector('[data-subscription-info]');
      const oneTimeOption = form?.querySelector('[data-one-time-option]');
      const oneTimePurchase = form?.querySelector('[data-one-time-purchase]');
      const sellingPlanOptions = [...(form?.querySelectorAll('[data-selling-plan-option]') || [])];
      const mediaItems = [...root.querySelectorAll('[data-product-media]')];
      const thumbnails = [...root.querySelectorAll('[data-gallery-thumbnail]')];
      const counter = root.querySelector('[data-gallery-counter]');
      const galleryStage = root.querySelector('.product-gallery__stage');
      const mobileGallery = window.matchMedia('(max-width: 989px)');
      const strings = {
        addToCart: root.dataset.addToCartText,
        soldOut: root.dataset.soldOutText,
        adding: root.dataset.addingMessage,
        added: root.dataset.addedMessage,
        addError: root.dataset.addErrorMessage,
        cartLabelTemplate: root.dataset.cartLabelTemplate
      };
      let currentMediaIndex = Math.max(0, mediaItems.findIndex((item) => !item.hidden));
      const kachingUi = root.querySelector('[data-kaching-offer-ui]');
      const kachingAppBlocks = root.querySelector('.main-product__app-blocks');
      const kachingPurchaseSlot = root.querySelector('[data-kaching-purchase-slot]');
      const landingOfferProperty = form?.querySelector('[data-landing-offer-property]');
      const landingPlanProperty = form?.querySelector('[data-landing-plan-property]');
      const purchaseTypeProperty = form?.querySelector('[data-purchase-type-property]');
      const supportedKachingOfferModes = new Set(['all', 'price_hike', 'standard', 'bogo']);
      const requestedKachingOfferMode = String(kachingUi?.dataset.offerMode || 'all').trim().toLowerCase();
      const kachingOfferMode = supportedKachingOfferModes.has(requestedKachingOfferMode)
        ? requestedKachingOfferMode
        : 'all';
      const kachingOfferBarIds = new Set(
        String(kachingUi?.dataset.offerBarIds || '')
          .split(',')
          .map((id) => id.trim().toLowerCase())
          .filter(Boolean)
      );
      const kachingPreselectedBarId = String(kachingUi?.dataset.preselectedBarId || '').trim();
      const kachingConvergenceRequired = Boolean(
        kachingUi && (kachingOfferMode !== 'all' || kachingOfferBarIds.size || kachingPreselectedBarId)
      );
      const addButtonInitiallyDisabled = Boolean(addButton?.disabled);
      if (kachingConvergenceRequired && addButton) {
        addButton.dataset.kachingConverged = 'false';
        addButton.disabled = true;
      }
      const requestedPurchasePreselection = String(kachingUi?.dataset.purchasePreselection || 'current')
        .trim()
        .toLowerCase();
      const kachingPurchasePreselection = ['subscription', 'one_time'].includes(requestedPurchasePreselection)
        ? requestedPurchasePreselection
        : (kachingOfferMode === 'standard' ? 'subscription' : 'current');
      const kachingState = {
        bundle: null,
        cards: new Map(),
        plans: new Map(),
        exactPricing: new Map(),
        ready: false,
        syncQueued: false,
        purchasePreferenceApplied: false,
        purchasePreferencePending: false,
        purchasePreferenceAttempts: 0,
        offerPreselectionApplied: false,
        publicSignature: '',
        publicState: {
          ready: false,
          selectedId: '',
          offerMode: kachingOfferMode,
          purchaseOption: '',
          plans: []
        }
      };

      const toCents = (value) => {
        const match = String(value || '').replace(/\s/g, '').match(/-?\d[\d,]*(?:\.\d{1,2})?/);
        if (!match) return 0;
        const number = Number(match[0].replace(/,/g, ''));
        return Number.isFinite(number) ? Math.round(number * 100) : 0;
      };

      const formatMoney = (cents) => {
        const locale = document.documentElement.lang || 'en-US';
        const currency = window.Shopify?.currency?.active || 'USD';
        try {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(cents / 100);
        } catch (error) {
          return `$${(cents / 100).toFixed(2)}`;
        }
      };

      const getDirectText = (node) => {
        if (!node) return '';
        return [...node.childNodes]
          .filter((child) => child.nodeType === 3)
          .map((child) => child.textContent || '')
          .join(' ')
          .trim();
      };

      const getKachingGiftData = (bar) => {
        return [...bar.querySelectorAll('.kaching-bundles__free-gift')].map((gift) => {
          const label = gift.querySelector('.kaching-bundles__free-gift__text')?.textContent?.trim() || '';
          const image = gift.querySelector('.kaching-bundles__free-gift__image');
          return {
            label,
            image: image?.currentSrc || image?.src || '',
            valueCents: toCents(gift.querySelector('.kaching-bundles__free-gift__full-price')?.textContent)
          };
        });
      };

      const toPositiveInteger = (value) => {
        const number = Number(value);
        return Number.isFinite(number) && number > 0 ? Math.floor(number) : 0;
      };

      const normalizeKachingResourceId = (value) => String(value || '').split('/').pop().trim();

      const getKachingBlock = () => (
        kachingState.bundle?.querySelector('kaching-bundles-block[deal-block], [deal-block]') || null
      );

      const readKachingJsonAttribute = (name) => {
        const block = getKachingBlock();
        if (!block) return {};
        try {
          return JSON.parse(block.getAttribute(name) || '{}');
        } catch (error) {
          return {};
        }
      };

      const getKachingDealConfiguration = () => readKachingJsonAttribute('deal-block');
      const getKachingProductConfiguration = () => readKachingJsonAttribute('product');

      const getKachingDealBars = (configuration = getKachingDealConfiguration()) => new Map(
        (Array.isArray(configuration.dealBars) ? configuration.dealBars : [])
          .filter((deal) => deal?.id != null)
          .map((deal) => [String(deal.id), deal])
      );

      const getKachingBarId = (bar, fallback = '') => String(
        bar?.dataset.dealBarId
          || bar?.querySelector('input[type="radio"]')?.value
          || fallback
      );

      const getKachingSourceBars = () => (
        kachingState.bundle
          ? [...kachingState.bundle.querySelectorAll('.kaching-bundles__bar')].filter((bar) => (
            !bar.closest('.kaching-bundles__subscriptions')
            && Boolean(bar.dataset.dealBarId || bar.querySelector('input[type="radio"][name^="kaching-bundles-deal-"]'))
          ))
          : []
      );

      const parseBxgyQuantities = (value) => {
        const text = String(value || '');
        const match = text.match(/\bbuy\s*(\d+)\D+get\s*(\d+)/i)
          || text.match(/\bb\s*(\d+)\s*g\s*(\d+)\b/i)
          || text.match(/\b(\d+)\s*\+\s*(\d+)\s*(?:free)?\b/i);
        if (!match) return null;
        const buyQuantity = toPositiveInteger(match[1]);
        const getQuantity = toPositiveInteger(match[2]);
        return buyQuantity && getQuantity ? { buyQuantity, getQuantity } : null;
      };

      const deriveKachingDealType = (deal, bar, title) => {
        const configuredType = String(deal?.dealBarType || bar?.dataset.dealBarType || '')
          .trim()
          .toLowerCase();
        if (['bxgy', 'bogo', 'buy-x-get-y'].includes(configuredType) || parseBxgyQuantities(title)) {
          return 'bxgy';
        }
        return configuredType || 'quantity-break';
      };

      const deriveKachingQuantity = (deal, bar, title, dealType, fallback) => {
        const parsedBxgy = parseBxgyQuantities([title, deal?.label, deal?.subtitle].filter(Boolean).join(' '));
        if (dealType === 'bxgy') {
          const buyQuantity = toPositiveInteger(deal?.buyQuantity) || parsedBxgy?.buyQuantity || 0;
          const getQuantity = toPositiveInteger(deal?.getQuantity) || parsedBxgy?.getQuantity || 0;
          if (buyQuantity && getQuantity) return buyQuantity + getQuantity;
        }

        const configuredQuantity = toPositiveInteger(deal?.quantity)
          || toPositiveInteger(bar?.dataset.quantity)
          || toPositiveInteger(bar?.dataset.bundleQuantity);
        if (configuredQuantity) return configuredQuantity;
        if (parsedBxgy) return parsedBxgy.buyQuantity + parsedBxgy.getQuantity;

        const monthOrPack = String(title || '').match(/\b(\d+)\s*(?:-|–|—|\s)?(?:months?|bottles?|packs?|units?)\b/i);
        if (monthOrPack) return toPositiveInteger(monthOrPack[1]);
        const multiplied = String(title || '').match(/(?:×|x)\s*(\d+)|\b(\d+)\s*(?:×|x)\b/i);
        if (multiplied) return toPositiveInteger(multiplied[1] || multiplied[2]);
        const buyOnly = String(title || '').match(/\bb(?:uy)?\s*(\d+)\b/i);
        if (buyOnly) return toPositiveInteger(buyOnly[1]);
        return toPositiveInteger(String(title || '').match(/\d+/)?.[0]) || fallback;
      };

      const deriveKachingOfferMode = (deal, bar, title, dealType) => {
        if (dealType === 'bxgy') return 'bogo';
        const descriptor = [
          bar?.dataset.offerMode,
          deal?.offerMode,
          deal?.label,
          deal?.title,
          deal?.subtitle,
          deal?.badgeText,
          title
        ].filter(Boolean).join(' ');
        if (/\b(?:b|buy)\s*1\b/i.test(descriptor)) return 'bogo';
        if (/price[\s_-]*(?:hike|spike)|intro(?:ductory)?|first\s+(?:order|month|delivery)|then\s*\$|rebill/i.test(descriptor)) {
          return 'price_hike';
        }
        if (/standard|regular|original\s+offer|\b\d+\s*(?:-|–|—|\s)?months?\s+plan\b/i.test(descriptor)) {
          return 'standard';
        }
        return '';
      };

      const isKachingPlanAllowed = (id, offerMode) => {
        if (kachingOfferBarIds.size) return kachingOfferBarIds.has(String(id).toLowerCase());
        if (kachingOfferMode === 'all') return true;
        return offerMode === kachingOfferMode;
      };

      const filterKachingSourceBar = (bar, allowed) => {
        if (kachingOfferMode === 'all' && !kachingOfferBarIds.size) return;
        if (!allowed) {
          bar.dataset.thalaOfferFiltered = 'true';
          bar.hidden = true;
          bar.setAttribute('aria-hidden', 'true');
        } else if (bar.dataset.thalaOfferFiltered === 'true') {
          delete bar.dataset.thalaOfferFiltered;
          bar.hidden = false;
          bar.removeAttribute('aria-hidden');
        }
      };

      const normalizeKachingPricing = (pricing, amountsAreCents) => {
        if (!pricing || typeof pricing !== 'object') return null;
        const amountToCents = (entry) => {
          const amount = Number(entry?.amount);
          if (!Number.isFinite(amount)) return 0;
          return amountsAreCents ? Math.round(amount) : Math.round(amount * 100);
        };
        return {
          discountedCents: amountToCents(pricing.discountedPrice),
          oneTimeCents: amountToCents(pricing.discountedPriceWithoutSellingPlan),
          fullCents: amountToCents(pricing.fullPrice),
          sellingPlanCents: new Map(
            (Array.isArray(pricing.discountedPricesForSellingPlans)
              ? pricing.discountedPricesForSellingPlans
              : [])
              .map((entry) => [
                normalizeKachingResourceId(entry.sellingPlanId),
                amountToCents(entry)
              ])
              .filter(([id, cents]) => id && cents)
          )
        };
      };

      const cacheKachingPricing = (dealBarId, pricing, amountsAreCents) => {
        const id = String(dealBarId || '');
        const normalized = normalizeKachingPricing(pricing, amountsAreCents);
        if (!id || !normalized) return;
        kachingState.exactPricing.set(id, normalized);
      };

      const captureSelectedKachingPricing = () => {
        const block = getKachingBlock();
        if (!block || typeof block.pricing !== 'function') return;
        const selectedId = String(
          block.selectedDealBarId
            || getKachingSourceBars().find((bar) => (
              bar.classList.contains('kaching-bundles__bar--selected')
            ))?.dataset.dealBarId
            || ''
        );
        try {
          cacheKachingPricing(selectedId, block.pricing(), false);
        } catch (error) {
          // Kaching is still hydrating; a later native event will retry.
        }
      };

      const captureKachingEventPricing = (event) => {
        const pricing = event?.detail?.pricing;
        if (!pricing) return;
        const selectedBar = getKachingSourceBars().find((bar) => (
          bar.classList.contains('kaching-bundles__bar--selected')
          || bar.querySelector('input[type="radio"][name^="kaching-bundles-deal-"]')?.checked
        ));
        const dealBarId = event.detail.dealBarId
          || event.detail.dealBar?.id
          || event.detail.selectedDealBarId
          || selectedBar?.dataset.dealBarId;
        cacheKachingPricing(dealBarId, pricing, true);
      };

      const getKachingVariantForDeal = (productConfiguration, deal, title) => {
        const variants = Array.isArray(productConfiguration.variants) ? productConfiguration.variants : [];
        const normalizedTitle = String(title || '').trim().toLowerCase();
        const configuredVariantIds = (Array.isArray(deal?.variantGIDs) ? deal.variantGIDs : [])
          .map(normalizeKachingResourceId);
        return variants.find((variant) => configuredVariantIds.includes(String(variant.id)))
          || variants.find((variant) => (
            Array.isArray(variant.options)
            && variant.options.some((option) => String(option).trim().toLowerCase() === normalizedTitle)
          ))
          || variants.find((variant) => String(variant.id) === String(productConfiguration.selectedVariantId))
          || variants[0]
          || null;
      };

      const getKachingOneTimeCents = (deal, dealType, quantity, variant, buyQuantity, getQuantity) => {
        const unitCents = toPositiveInteger(variant?.price);
        if (!unitCents) return 0;

        if (dealType === 'bxgy') {
          const buyUnits = buyQuantity || toPositiveInteger(deal?.buyQuantity);
          const getUnits = getQuantity || toPositiveInteger(deal?.getQuantity);
          if (!buyUnits) return 0;
          const getDiscountType = String(deal?.getDiscountType || '').toLowerCase();
          const getDiscountValue = Number(deal?.getDiscountValue);
          let getUnitCents = unitCents;
          if (/free/i.test(String(deal?.title || '')) || (getDiscountType === 'percentage' && getDiscountValue >= 100)) {
            getUnitCents = 0;
          } else if (getDiscountType === 'specific' && Number.isFinite(getDiscountValue)) {
            getUnitCents = Math.round(getDiscountValue * 100);
          } else if (getDiscountType === 'percentage' && Number.isFinite(getDiscountValue)) {
            getUnitCents = Math.round(unitCents * (100 - getDiscountValue) / 100);
          } else if (/fixed|amount/.test(getDiscountType) && Number.isFinite(getDiscountValue)) {
            getUnitCents = Math.max(0, unitCents - Math.round(getDiscountValue * 100));
          }
          return (unitCents * buyUnits) + (getUnitCents * getUnits);
        }

        const discountType = String(deal?.discountType || 'default').toLowerCase();
        const discountValue = Number(deal?.discountValue);
        const fullCents = unitCents * quantity;
        if (discountType === 'specific' && Number.isFinite(discountValue)) {
          return Math.round(discountValue * 100);
        }
        if (discountType === 'percentage' && Number.isFinite(discountValue)) {
          return Math.round(fullCents * (100 - discountValue) / 100);
        }
        if (/fixed|amount/.test(discountType) && Number.isFinite(discountValue)) {
          return Math.max(0, fullCents - Math.round(discountValue * 100));
        }
        return fullCents;
      };

      const getKachingSubscriptionCents = (productConfiguration, variant, sellingPlanId, quantity, oneTimeCents) => {
        if (!sellingPlanId) return 0;
        const variantPlan = (Array.isArray(variant?.sellingPlans) ? variant.sellingPlans : [])
          .find((plan) => normalizeKachingResourceId(plan.id) === sellingPlanId);
        if (toPositiveInteger(variantPlan?.price)) return toPositiveInteger(variantPlan.price) * quantity;

        const productPlan = (Array.isArray(productConfiguration.sellingPlans)
          ? productConfiguration.sellingPlans
          : [])
          .find((plan) => normalizeKachingResourceId(plan.id) === sellingPlanId);
        const adjustmentType = String(productPlan?.priceAdjustment?.type || '').toLowerCase();
        const adjustmentValue = Number(productPlan?.priceAdjustment?.value);
        if (adjustmentType === 'price' && Number.isFinite(adjustmentValue)) {
          return Math.round(adjustmentValue) * quantity;
        }
        if (adjustmentType === 'percentage' && Number.isFinite(adjustmentValue)) {
          return Math.round(oneTimeCents * (100 - adjustmentValue) / 100);
        }
        return 0;
      };

      const getKachingPlanPricing = ({
        id,
        bar,
        deal,
        dealType,
        quantity,
        buyQuantity,
        getQuantity,
        sellingPlanId,
        configuration,
        productConfiguration,
        variant
      }) => {
        const unitPriceCents = toCents(getDirectText(bar.querySelector('.kaching-bundles__bar-price')));
        const originalUnitCents = toCents(bar.querySelector('.kaching-bundles__bar-full-price')?.textContent);
        const displayedTotalCents = configuration.showPricesPerItem === false
          ? unitPriceCents
          : unitPriceCents * quantity;
        const displayedCompareCents = configuration.showPricesPerItem === false
          ? originalUnitCents
          : originalUnitCents * quantity;

        if (!kachingConvergenceRequired) {
          const compareCents = Math.max(displayedTotalCents, displayedCompareCents || displayedTotalCents);
          return {
            totalCents: displayedTotalCents,
            compareCents,
            saveCents: Math.max(0, compareCents - displayedTotalCents),
            priceExact: false
          };
        }

        const cached = kachingState.exactPricing.get(id);
        const derivedOneTimeCents = getKachingOneTimeCents(
          deal,
          dealType,
          quantity,
          variant,
          buyQuantity,
          getQuantity
        );
        const oneTimeCents = cached?.oneTimeCents || derivedOneTimeCents || displayedTotalCents;
        const subscriptionCents = cached?.sellingPlanCents.get(sellingPlanId)
          || getKachingSubscriptionCents(
            productConfiguration,
            variant,
            sellingPlanId,
            quantity,
            oneTimeCents
          );
        const purchaseOption = readKachingPurchaseOption();
        const totalCents = purchaseOption === 'subscription' && subscriptionCents
          ? subscriptionCents
          : (oneTimeCents || cached?.discountedCents || displayedTotalCents);
        const fullProductCents = toPositiveInteger(variant?.price) * quantity;
        const compareCents = purchaseOption === 'subscription'
          ? Math.max(totalCents, oneTimeCents)
          : Math.max(totalCents, dealType === 'bxgy' ? fullProductCents : totalCents);
        return {
          totalCents,
          compareCents,
          saveCents: Math.max(0, compareCents - totalCents),
          priceExact: Boolean(
            cached?.oneTimeCents
            || derivedOneTimeCents
            || (configuration.showPricesPerItem === false && displayedTotalCents)
          )
        };
      };

      const readKachingPlans = () => {
        if (!kachingState.bundle) return [];
        captureSelectedKachingPricing();
        const configuration = getKachingDealConfiguration();
        const productConfiguration = getKachingProductConfiguration();
        const configuredDeals = getKachingDealBars(configuration);
        return getKachingSourceBars().map((bar, index) => {
          const id = getKachingBarId(bar, String(index));
          const deal = configuredDeals.get(id);
          const title = bar.querySelector('.kaching-bundles__bar-title')?.textContent?.trim() || `Option ${index + 1}`;
          const dealType = deriveKachingDealType(deal, bar, title);
          const quantity = deriveKachingQuantity(deal, bar, title, dealType, index + 1);
          const detectedOfferMode = deriveKachingOfferMode(deal, bar, title, dealType);
          const allowed = isKachingPlanAllowed(id, detectedOfferMode);
          filterKachingSourceBar(bar, allowed);
          if (!allowed) return null;
          const offerMode = kachingOfferMode === 'all' ? detectedOfferMode : kachingOfferMode;
          const bxgyQuantities = parseBxgyQuantities([title, deal?.label, deal?.subtitle].filter(Boolean).join(' '));
          const buyQuantity = toPositiveInteger(deal?.buyQuantity) || bxgyQuantities?.buyQuantity || 0;
          const getQuantity = toPositiveInteger(deal?.getQuantity) || bxgyQuantities?.getQuantity || 0;
          const sellingPlanId = normalizeKachingResourceId(deal?.sellingPlanGid || deal?.sellingPlanId);
          const variant = getKachingVariantForDeal(productConfiguration, deal, title);
          const pricing = getKachingPlanPricing({
            id,
            bar,
            deal,
            dealType,
            quantity,
            buyQuantity,
            getQuantity,
            sellingPlanId,
            configuration,
            productConfiguration,
            variant
          });
          const gifts = getKachingGiftData(bar);
          const beauty = gifts.find((gift) => /(?:beauty|magic) oil/i.test(gift.label));
          const guides = gifts.filter((gift) => /guide/i.test(gift.label));
          const shipping = gifts.find((gift) => /shipping/i.test(gift.label));
          return {
            id,
            index,
            bar,
            title,
            quantity,
            buyQuantity,
            getQuantity,
            dealType,
            offerMode,
            sellingPlanId,
            ...pricing,
            gifts,
            beauty,
            guides,
            shipping
          };
        }).filter(Boolean);
      };

      const setKachingImage = (image, source) => {
        if (!image) return;
        if (source) {
          image.src = source;
          image.hidden = false;
        } else {
          image.removeAttribute('src');
          image.hidden = true;
        }
      };

      const formatKachingSave = (amount) => {
        return (kachingUi?.dataset.saveLabel || 'Save __AMOUNT__').replace('__AMOUNT__', amount);
      };

      const getKachingBadge = (plan, maxQuantity) => {
        if (plan.quantity === 3) return kachingUi?.dataset.mostPopularLabel || 'Most Popular';
        if (plan.quantity === maxQuantity) return kachingUi?.dataset.bestValueLabel || 'Best Value';
        return '';
      };

      const updateKachingCard = (card, plan, maxQuantity) => {
        const hasSavings = plan.saveCents > 0 && plan.compareCents > plan.totalCents;
        const saveText = hasSavings ? formatKachingSave(formatMoney(plan.saveCents)) : '';
        card.dataset.kachingOfferId = plan.id;
        card.setAttribute('aria-label', [plan.title, formatMoney(plan.totalCents), saveText].filter(Boolean).join(', '));
        card.querySelector('[data-kaching-offer-title]').textContent = plan.title;
        const save = card.querySelector('[data-kaching-offer-save]');
        save.textContent = saveText;
        save.hidden = !hasSavings;
        card.querySelector('[data-kaching-offer-price]').textContent = formatMoney(plan.totalCents);
        const compare = card.querySelector('[data-kaching-offer-compare]');
        compare.textContent = hasSavings ? formatMoney(plan.compareCents) : '';
        compare.hidden = !hasSavings;

        const badge = card.querySelector('[data-kaching-offer-badge]');
        const badgeLabel = getKachingBadge(plan, maxQuantity);
        badge.textContent = badgeLabel;
        badge.hidden = !badgeLabel;

        const productStack = card.querySelector('[data-kaching-product-stack]');
        const visibleProducts = Math.min(plan.quantity, 3);
        productStack.dataset.stackCount = String(visibleProducts);
        [...productStack.querySelectorAll('img')].forEach((image, imageIndex) => {
          image.hidden = imageIndex >= visibleProducts;
        });
        const quantityBadge = card.querySelector('[data-kaching-product-quantity]');
        quantityBadge.textContent = `×${plan.quantity}`;
        quantityBadge.hidden = plan.quantity <= 3;
      };

      const renderKachingCards = (plans) => {
        if (!kachingUi || !plans.length) return;
        const list = kachingUi.querySelector('[data-kaching-offer-list]');
        const template = kachingUi.querySelector('[data-kaching-offer-template]');
        if (!list || !template) return;
        const maxQuantity = Math.max(...plans.map((plan) => plan.quantity));

        list.replaceChildren();
        kachingState.cards.clear();
        plans.forEach((plan) => {
          const fragment = template.content.cloneNode(true);
          const card = fragment.querySelector('.kaching-offer-card');
          updateKachingCard(card, plan, maxQuantity);
          card.addEventListener('click', () => {
            setKachingSubmitConvergence(false);
            const liveBar = kachingState.bundle?.querySelector(`.kaching-bundles__bar[data-deal-bar-id="${CSS.escape(plan.id)}"]`);
            const radio = liveBar?.querySelector('input[type="radio"][name^="kaching-bundles-deal-"]');
            if (radio && !radio.checked) radio.click();
            queueKachingSync();
          });
          list.appendChild(fragment);
          kachingState.cards.set(plan.id, card);
        });
      };

      const updateKachingGiftPanel = (plan) => {
        if (!kachingUi || !plan) return;
        const cleanGiftLabel = (gift, fallback) => {
          return gift?.label
            ?.replace(/^\s*\+\s*/i, '')
            .replace(/\s+/g, ' ')
            .trim() || fallback;
        };

        const beautyItem = kachingUi.querySelector('[data-kaching-beauty-item]');
        if (beautyItem) beautyItem.hidden = !plan.beauty;
        setKachingImage(kachingUi.querySelector('[data-kaching-gift-beauty]'), plan.beauty?.image);
        kachingUi.querySelector('[data-kaching-beauty-value]').textContent = plan.beauty ? formatMoney(plan.beauty.valueCents) : '';
        kachingUi.querySelector('[data-kaching-beauty-label]').textContent =
          plan.beauty ? cleanGiftLabel(plan.beauty, '') : '';

        [...kachingUi.querySelectorAll('[data-kaching-guide-item]')].forEach((item, index) => {
          const guide = plan.guides[index];
          item.hidden = !guide;
          setKachingImage(item.querySelector('[data-kaching-guide-image]'), guide?.image);
          item.querySelector('[data-kaching-guide-value]').textContent = guide ? formatMoney(guide.valueCents) : '';
          item.querySelector('[data-kaching-guide-label]').textContent =
            cleanGiftLabel(guide, `Personalized Guide ${index + 1}`);
        });

        kachingUi.querySelector('[data-kaching-shipping-label]').textContent =
          cleanGiftLabel(plan.shipping, kachingUi.dataset.freeShippingLabel || 'Free Shipping');
      };

      const getPersistentKachingPurchaseContainers = (scope) => (
        scope
          ? [...scope.querySelectorAll('.kaching-bundles__subscriptions')].filter((candidate) => (
            !candidate.classList.contains('kaching-bundles__subscriptions--link')
            && (
              candidate.classList.contains('kaching-bundles__bars')
              || candidate.classList.contains('kaching-bundles__subscriptions--checkbox')
              || candidate.querySelector('.kaching-bundles__subscriptions__card, [role="checkbox"]')
            )
          ))
          : []
      );

      const mountKachingPurchaseControl = () => {
        if (kachingOfferMode !== 'standard' || !kachingPurchaseSlot || !kachingState.bundle) return false;
        const slottedContainer = getPersistentKachingPurchaseContainers(kachingPurchaseSlot)[0];
        const liveContainer = getPersistentKachingPurchaseContainers(kachingState.bundle)[0];
        const container = liveContainer || slottedContainer;
        if (!container) {
          kachingPurchaseSlot.hidden = true;
          return false;
        }

        if (container.parentElement !== kachingPurchaseSlot) {
          kachingPurchaseSlot.replaceChildren(container);
        }
        kachingPurchaseSlot.hidden = false;
        if (container.dataset.thalaPurchaseSync !== 'true') {
          container.dataset.thalaPurchaseSync = 'true';
          container.addEventListener('click', () => {
            setKachingSubmitConvergence(false);
            window.requestAnimationFrame(() => {
              window.requestAnimationFrame(queueKachingSync);
            });
          });
        }
        return true;
      };

      const readKachingPurchaseOption = () => {
        const sellingPlanInput = form?.querySelector('input[name="selling_plan"]');
        if (String(sellingPlanInput?.value || '').trim()) return 'subscription';

        const bundleProperty = form?.querySelector('input[name="properties[__kaching_bundles]"]');
        if (bundleProperty) {
          try {
            const payload = JSON.parse(bundleProperty.value || '{}');
            return payload?.sellingPlan?.id ? 'subscription' : 'one_time';
          } catch (error) {
            return sellingPlanInput ? 'one_time' : '';
          }
        }
        return sellingPlanInput ? 'one_time' : '';
      };

      const getLandingPlanKey = (plan) => {
        if (!plan) return '';
        const quantity = toPositiveInteger(plan.quantity);

        if (kachingOfferMode === 'bogo') {
          const buyQuantity = toPositiveInteger(plan.buyQuantity);
          const getQuantity = toPositiveInteger(plan.getQuantity);
          if (buyQuantity && getQuantity) return `b${buyQuantity}g${getQuantity}`;
          if (quantity === 1) return 'b1';
          if (quantity === 3) return 'b2g1';
          if (quantity === 5) return 'b3g2';
        }

        if (kachingOfferMode === 'standard' || kachingOfferMode === 'price_hike') {
          const titleMonths = String(plan.title || '').match(/\b(\d+)\s*(?:-|–|—|\s)?months?\b/i);
          const months = toPositiveInteger(titleMonths?.[1]) || quantity;
          if (months) return `${months}_month`;
        }

        return String(plan.title || plan.id || '')
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '_')
          .replace(/^_+|_+$/g, '');
      };

      const syncLandingAttribution = (selectedPlan, purchaseOption = readKachingPurchaseOption()) => {
        const attributionInputs = [landingOfferProperty, landingPlanProperty, purchaseTypeProperty];
        if (attributionInputs.every((input) => !input)) return true;
        if (attributionInputs.some((input) => !input)) return false;

        const landingPlan = getLandingPlanKey(selectedPlan);
        const normalizedPurchaseType = ['subscription', 'one_time'].includes(purchaseOption)
          ? purchaseOption
          : '';
        landingOfferProperty.value = kachingOfferMode;
        landingPlanProperty.value = landingPlan;
        purchaseTypeProperty.value = normalizedPurchaseType;
        return Boolean(
          ['price_hike', 'standard', 'bogo'].includes(landingOfferProperty.value)
          && landingPlanProperty.value
          && purchaseTypeProperty.value
        );
      };

      const getKachingPurchaseControl = (purchaseOption) => {
        if (!kachingState.bundle) return null;
        const pattern = purchaseOption === 'subscription'
          ? /subscribe|subscription|recurring|automatic\s+shipment/i
          : /one[\s_-]*time|buy\s+once|single\s+purchase|no\s+savings/i;
        const containers = [kachingPurchaseSlot, kachingState.bundle]
          .filter(Boolean)
          .flatMap((scope) => getPersistentKachingPurchaseContainers(scope));
        const controls = [...new Set(containers.flatMap((container) => [
          ...container.querySelectorAll('button, input[type="radio"], [role="radio"], [role="checkbox"], :scope > .kaching-bundles__bar')
        ]))].filter((control) => !control.closest('[data-deal-bar-id]'));
        const matchingControl = controls.find((control) => {
            const label = control.id
              ? root.querySelector(`label[for="${CSS.escape(control.id)}"]`)?.textContent
              : control.closest('label')?.textContent;
            const descriptor = [
              control.textContent,
              control.getAttribute('aria-label'),
              control.getAttribute('data-purchase-option'),
              control.getAttribute('data-purchase-type'),
              control.getAttribute('name'),
              control.getAttribute('value'),
              label
            ].filter(Boolean).join(' ');
            return pattern.test(descriptor)
              && !control.disabled
              && control.getAttribute('aria-disabled') !== 'true';
          });
        if (matchingControl) return matchingControl;
        if (containers.some((container) => container.classList.contains('kaching-bundles__subscriptions--checkbox'))) {
          return controls.find((control) => (
            control.matches('[role="checkbox"], .kaching-bundles__bar')
            && !control.disabled
            && control.getAttribute('aria-disabled') !== 'true'
          )) || null;
        }
        return null;
      };

      const applyKachingPurchasePreselection = () => {
        if (
          kachingPurchasePreselection === 'current'
          || kachingState.purchasePreferenceApplied
          || kachingState.purchasePreferencePending
        ) return;

        if (readKachingPurchaseOption() === kachingPurchasePreselection) {
          kachingState.purchasePreferenceApplied = true;
          return;
        }
        if (kachingState.purchasePreferenceAttempts >= 2) return;

        const control = getKachingPurchaseControl(kachingPurchasePreselection);
        if (!control) return;
        kachingState.purchasePreferencePending = true;
        kachingState.purchasePreferenceAttempts += 1;
        try {
          control.click();
        } catch (error) {
          kachingState.purchasePreferenceAttempts = 2;
        }
        window.setTimeout(() => {
          kachingState.purchasePreferencePending = false;
          queueKachingSync();
        }, 0);
      };

      const getKachingPreselectionTarget = (plans) => {
        if (kachingPreselectedBarId) {
          return {
            required: true,
            plan: plans.find((plan) => plan.id.toLowerCase() === kachingPreselectedBarId.toLowerCase()) || null
          };
        }
        if (kachingOfferMode === 'bogo') {
          return {
            required: true,
            plan: plans.find((plan) => (
              plan.dealType === 'bxgy'
              && (
                (plan.buyQuantity === 2 && plan.getQuantity === 1)
                || plan.quantity === 3
              )
            )) || null
          };
        }
        if (['standard', 'price_hike'].includes(kachingOfferMode)) {
          return {
            required: true,
            plan: plans.find((plan) => /\b3\s*(?:-|–|—|\s)?months?\b/i.test(plan.title))
              || plans.find((plan) => plan.dealType !== 'bxgy' && plan.quantity === 3)
              || null
          };
        }
        return { required: false, plan: null };
      };

      const applyKachingOfferPreselection = (plans) => {
        if (kachingState.offerPreselectionApplied) return true;
        const target = getKachingPreselectionTarget(plans);
        if (!target.required) {
          kachingState.offerPreselectionApplied = true;
          return true;
        }
        if (!target.plan) return false;

        const radio = target.plan.bar.querySelector('input[type="radio"][name^="kaching-bundles-deal-"]');
        const nativeSelected = target.plan.bar.classList.contains('kaching-bundles__bar--selected');
        if (nativeSelected && radio?.checked) {
          kachingState.offerPreselectionApplied = true;
          return true;
        }
        if (!radio || radio.disabled) return false;

        setKachingSubmitConvergence(false);
        radio.click();
        queueKachingSync();
        return false;
      };

      const cloneKachingPublicState = () => ({
        ready: kachingState.publicState.ready,
        selectedId: kachingState.publicState.selectedId,
        offerMode: kachingState.publicState.offerMode,
        purchaseOption: kachingState.publicState.purchaseOption,
        plans: kachingState.publicState.plans.map((plan) => ({
          ...plan,
          gifts: plan.gifts.map((gift) => ({ ...gift }))
        }))
      });

      const publishKachingState = (plans, selectedPlan) => {
        const maxQuantity = plans.length ? Math.max(...plans.map((plan) => plan.quantity)) : 0;
        const nextState = {
          ready: Boolean(plans.length && selectedPlan),
          selectedId: selectedPlan?.id || '',
          offerMode: kachingOfferMode,
          purchaseOption: readKachingPurchaseOption(),
          plans: plans.map((plan) => ({
            id: plan.id,
            title: plan.title,
            quantity: plan.quantity,
            dealType: plan.dealType,
            offerMode: plan.offerMode,
            totalCents: plan.totalCents,
            compareCents: plan.compareCents,
            saveCents: plan.saveCents,
            priceExact: plan.priceExact,
            price: formatMoney(plan.totalCents),
            comparePrice: formatMoney(plan.compareCents),
            save: formatMoney(plan.saveCents),
            badge: getKachingBadge(plan, maxQuantity),
            gifts: plan.gifts
              .filter((gift) => gift.label)
              .map((gift) => ({
                label: gift.label,
                valueCents: gift.valueCents,
                value: gift.valueCents ? formatMoney(gift.valueCents) : ''
              }))
          }))
        };
        syncLandingAttribution(selectedPlan, nextState.purchaseOption);
        const signature = JSON.stringify(nextState);
        if (signature === kachingState.publicSignature) return;
        kachingState.publicSignature = signature;
        kachingState.publicState = nextState;
        document.dispatchEvent(new CustomEvent('thala:kaching:state', {
          detail: cloneKachingPublicState()
        }));
      };

      const isKachingSelectedPricingExact = (plan, purchaseOption) => {
        if (!kachingConvergenceRequired) return true;
        captureSelectedKachingPricing();
        const exactPricing = kachingState.exactPricing.get(plan.id);
        if (!exactPricing || !plan.priceExact) return false;

        if (purchaseOption === 'subscription') {
          const subscriptionCents = exactPricing.sellingPlanCents.get(plan.sellingPlanId)
            || exactPricing.discountedCents;
          const oneTimeCents = exactPricing.oneTimeCents;
          return Boolean(
            subscriptionCents
            && oneTimeCents
            && plan.totalCents === subscriptionCents
            && plan.compareCents === Math.max(subscriptionCents, oneTimeCents)
          );
        }

        const oneTimeCents = exactPricing.oneTimeCents || exactPricing.discountedCents;
        return Boolean(
          purchaseOption === 'one_time'
          && oneTimeCents
          && plan.totalCents === oneTimeCents
          && plan.compareCents >= plan.totalCents
        );
      };

      const isKachingSelectionConverged = () => {
        if (!kachingConvergenceRequired) return true;
        const failConvergence = (reason) => {
          if (addButton) addButton.dataset.kachingConvergenceReason = reason;
          return false;
        };
        const allowedPlans = [...kachingState.plans.values()];
        const nativeSelectedBars = getKachingSourceBars().filter((bar) => (
          bar.classList.contains('kaching-bundles__bar--selected')
        ));
        const checkedBars = getKachingSourceBars().filter((bar) => (
          bar.querySelector('input[type="radio"][name^="kaching-bundles-deal-"]')?.checked
        ));
        if (nativeSelectedBars.length !== 1 || checkedBars.length !== 1) {
          return failConvergence('native-selection');
        }

        const nativeSelectedId = getKachingBarId(nativeSelectedBars[0]);
        const checkedId = getKachingBarId(checkedBars[0]);
        const selectedPlan = allowedPlans.find((plan) => plan.id === nativeSelectedId);
        if (
          !selectedPlan
          || checkedId !== selectedPlan.id
          || !kachingState.publicState.ready
          || kachingState.publicState.selectedId !== selectedPlan.id
          || !kachingState.offerPreselectionApplied
          || kachingState.purchasePreferencePending
          || (kachingPurchasePreselection !== 'current' && !kachingState.purchasePreferenceApplied)
        ) return failConvergence('adapter-selection');

        const sellingPlanInput = form?.querySelector('input[type="hidden"][name="selling_plan"]');
        const selectedSellingPlanId = normalizeKachingResourceId(sellingPlanInput?.value);
        const purchaseOption = readKachingPurchaseOption();
        if (!syncLandingAttribution(selectedPlan, purchaseOption)) {
          return failConvergence('offer-attribution');
        }
        if (!isKachingSelectedPricingExact(selectedPlan, purchaseOption)) {
          return failConvergence('exact-pricing');
        }
        if (purchaseOption === 'subscription') {
          const sellingPlanMatches = Boolean(
            selectedPlan.sellingPlanId
            && selectedSellingPlanId
            && selectedPlan.sellingPlanId === selectedSellingPlanId
          );
          if (!sellingPlanMatches) return failConvergence('selling-plan');
          if (addButton) delete addButton.dataset.kachingConvergenceReason;
          return true;
        }
        if (purchaseOption !== 'one_time' || selectedSellingPlanId) {
          return failConvergence('purchase-option');
        }
        if (addButton) delete addButton.dataset.kachingConvergenceReason;
        return true;
      };

      const setKachingSubmitConvergence = (converged) => {
        if (!kachingConvergenceRequired || !addButton) return;
        addButton.dataset.kachingConverged = String(Boolean(converged));
        if (!converged) {
          addButton.disabled = true;
          return;
        }
        const selectedRadio = [...kachingState.plans.values()]
          .find((plan) => plan.id === kachingState.publicState.selectedId)
          ?.bar.querySelector('input[type="radio"][name^="kaching-bundles-deal-"]');
        addButton.disabled = addButtonInitiallyDisabled || Boolean(selectedRadio?.disabled);
      };

      if (kachingConvergenceRequired && addButton) {
        const convergenceObserver = new MutationObserver(() => {
          if (addButton.dataset.kachingConverged === 'false' && !addButton.disabled) {
            addButton.disabled = true;
          }
        });
        convergenceObserver.observe(addButton, { attributes: true, attributeFilter: ['disabled'] });
      }

      const syncKachingSelection = () => {
        if (!kachingState.ready || !kachingUi || !kachingState.bundle) return;
        setKachingSubmitConvergence(false);
        const plans = readKachingPlans();
        if (!plans.length) {
          kachingState.plans.clear();
          kachingState.cards.clear();
          kachingUi.querySelector('[data-kaching-offer-list]')?.replaceChildren();
          kachingUi.hidden = true;
          publishKachingState([], null);
          return;
        }
        kachingUi.hidden = false;
        mountKachingPurchaseControl();
        kachingState.plans = new Map(plans.map((plan) => [plan.id, plan]));

        const cardsMatchPlans = kachingState.cards.size === plans.length
          && plans.every((plan) => kachingState.cards.has(plan.id));
        if (!cardsMatchPlans) {
          renderKachingCards(plans);
        } else {
          const maxQuantity = Math.max(...plans.map((plan) => plan.quantity));
          plans.forEach((plan) => {
            const card = kachingState.cards.get(plan.id);
            if (card) updateKachingCard(card, plan, maxQuantity);
          });
        }

        if (!applyKachingOfferPreselection(plans)) return;

        let selectedPlan = plans.find((plan) => (
          plan.bar.classList.contains('kaching-bundles__bar--selected')
          || plan.bar.querySelector('input[type="radio"]')?.checked
        ));
        if (!selectedPlan) {
          const allowedRadio = plans[0].bar.querySelector('input[type="radio"][name^="kaching-bundles-deal-"]');
          if (allowedRadio && !allowedRadio.disabled && !allowedRadio.checked) {
            allowedRadio.click();
            queueKachingSync();
            return;
          }
          selectedPlan = plans[0];
        }

        kachingState.cards.forEach((card, id) => {
          card.setAttribute('aria-checked', String(id === selectedPlan.id));
        });
        kachingUi.querySelector('[data-kaching-summary-price]').textContent = formatMoney(selectedPlan.totalCents);
        kachingUi.querySelector('[data-kaching-summary-compare]').textContent = formatMoney(selectedPlan.compareCents);
        kachingUi.querySelector('[data-kaching-summary-save]').textContent =
          `${kachingUi.dataset.bundleLabel} · ${formatKachingSave(formatMoney(selectedPlan.saveCents))}`;
        currentPrices.forEach((node) => { node.textContent = formatMoney(selectedPlan.totalCents); });
        comparePrices.forEach((node) => {
          node.textContent = formatMoney(selectedPlan.compareCents);
          node.classList.toggle('is-hidden', selectedPlan.compareCents <= selectedPlan.totalCents);
        });
        updateKachingGiftPanel(selectedPlan);
        if (subscriptionInfo) subscriptionInfo.hidden = false;
        applyKachingPurchasePreselection();
        publishKachingState(plans, selectedPlan);
        setKachingSubmitConvergence(isKachingSelectionConverged());
      };

      const queueKachingSync = () => {
        if (kachingState.syncQueued) return;
        kachingState.syncQueued = true;
        window.requestAnimationFrame(() => {
          kachingState.syncQueued = false;
          syncKachingSelection();
        });
      };

      const selectKachingPlan = (dealId) => {
        if (!kachingState.ready || !kachingState.bundle || !dealId) return false;
        const plan = readKachingPlans().find((candidate) => candidate.id === String(dealId));
        const radio = plan?.bar?.querySelector('input[type="radio"][name^="kaching-bundles-deal-"]');
        if (!radio || radio.disabled) return false;
        setKachingSubmitConvergence(false);
        if (!radio.checked) {
          radio.click();
        } else {
          queueKachingSync();
        }
        return true;
      };

      let kachingCheckoutPending = false;

      const waitForKachingSelection = (dealId) => new Promise((resolve) => {
        let timeoutId;
        const selectedRadio = () => {
          const plan = readKachingPlans().find((candidate) => candidate.id === String(dealId));
          return plan?.bar?.querySelector('input[type="radio"][name^="kaching-bundles-deal-"]');
        };
        const cleanup = () => {
          document.removeEventListener('thala:kaching:state', check);
          buttonObserver.disconnect();
          window.clearTimeout(timeoutId);
        };
        const check = () => {
          const selectionReady =
            kachingState.publicState.selectedId === String(dealId)
            && selectedRadio()?.checked
            && isKachingSelectionConverged()
            && !addButton.disabled;
          if (!selectionReady) return;
          cleanup();
          resolve(true);
        };
        const buttonObserver = new MutationObserver(check);
        buttonObserver.observe(addButton, { attributes: true, attributeFilter: ['disabled'] });
        document.addEventListener('thala:kaching:state', check);
        timeoutId = window.setTimeout(() => {
          cleanup();
          resolve(false);
        }, 2500);
        check();
      });

      const checkoutKachingPlan = (dealId) => {
        if (!form || !addButton || addButton.disabled || kachingCheckoutPending) return false;
        const targetId = String(dealId || kachingState.publicState.selectedId || '');
        if (!targetId || !selectKachingPlan(targetId)) return false;
        kachingCheckoutPending = true;
        waitForKachingSelection(targetId).then((selectionReady) => {
          if (!selectionReady) {
            kachingCheckoutPending = false;
            document.dispatchEvent(new CustomEvent('thala:kaching:checkout-error', {
              detail: { message: 'Your bundle selection did not finish loading. Please try again.' }
            }));
            return;
          }
          form.dataset.thalaDirectCheckout = 'true';
          try {
            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit(addButton);
            } else {
              addButton.click();
            }
          } catch (error) {
            kachingCheckoutPending = false;
            delete form.dataset.thalaDirectCheckout;
            document.dispatchEvent(new CustomEvent('thala:kaching:checkout-error', {
              detail: { message: error.message }
            }));
          }
        });
        return true;
      };

      window.ThalaKachingBundles = {
        getState: cloneKachingPublicState,
        selectPlan: selectKachingPlan,
        checkout: checkoutKachingPlan
      };

      const mountKachingOfferUi = () => {
        if (!kachingUi || kachingState.ready) return kachingState.ready;
        const bundle = root.querySelector('kaching-bundle');
        kachingState.bundle = bundle;
        const bars = getKachingSourceBars();
        if (!bundle || bars.length < 1) return false;

        const plans = readKachingPlans();
        if (!plans.length) return false;
        renderKachingCards(plans);
        kachingState.plans = new Map(plans.map((plan) => [plan.id, plan]));
        kachingState.ready = true;

        ['deal-bar-selected', 'variants-changed', 'items-changed'].forEach((eventName) => {
          bundle.addEventListener(eventName, (event) => {
            captureKachingEventPricing(event);
            setKachingSubmitConvergence(false);
            queueKachingSync();
          });
        });
        bundle.addEventListener('change', () => {
          setKachingSubmitConvergence(false);
          queueKachingSync();
        });

        const isKachingFormInput = (node) => (
          node?.nodeType === 1
          && (
            node.matches?.('input[name="selling_plan"], input[name="properties[__kaching_bundles]"]')
            || node.querySelector?.('input[name="selling_plan"], input[name="properties[__kaching_bundles]"]')
          )
        );
        const formObserver = new MutationObserver((mutations) => {
          const kachingSelectionChanged = mutations.some((mutation) => (
            (mutation.type === 'attributes' && isKachingFormInput(mutation.target))
            || [...mutation.addedNodes, ...mutation.removedNodes].some(isKachingFormInput)
          ));
          if (!kachingSelectionChanged) return;
          setKachingSubmitConvergence(false);
          queueKachingSync();
        });
        if (form) formObserver.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
        const bundleObserver = new MutationObserver(queueKachingSync);
        bundleObserver.observe(bundle, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['class', 'src', 'value']
        });

        kachingUi.hidden = false;
        if (kachingAppBlocks) {
          kachingAppBlocks.setAttribute('aria-hidden', 'true');
          kachingAppBlocks.querySelectorAll('input, a, button, [tabindex]').forEach((element) => {
            element.tabIndex = -1;
          });
        }
        root.classList.add('is-kaching-offers-ready');
        syncKachingSelection();
        return true;
      };

      if (kachingUi && !mountKachingOfferUi() && kachingAppBlocks) {
        const hydrationObserver = new MutationObserver(() => {
          if (mountKachingOfferUi()) hydrationObserver.disconnect();
        });
        hydrationObserver.observe(kachingAppBlocks, { childList: true, subtree: true });
        window.addEventListener('kaching-bundles-initialized', mountKachingOfferUi, { once: true });
        window.addEventListener('kaching-bundles-block-loaded', mountKachingOfferUi, { once: true });
      }

      const renderPrice = (price, compare) => {
        currentPrices.forEach((node) => { node.textContent = price || ''; });
        comparePrices.forEach((node) => {
          node.textContent = compare || '';
          node.classList.toggle('is-hidden', !compare);
        });
        if (saleBadge) saleBadge.classList.toggle('is-hidden', !compare);
      };

      const updatePurchasePrice = () => {
        const selectedPurchase = form?.querySelector('input[name="selling_plan"]:checked:not(:disabled)');
        const selectedVariant = variantCards.find((card) => card.querySelector('[data-variant-radio]')?.checked);
        renderPrice(
          selectedPurchase?.dataset.price || selectedVariant?.dataset.price,
          selectedPurchase?.dataset.compare || selectedVariant?.dataset.compare
        );
        if (subscriptionInfo) subscriptionInfo.hidden = !selectedPurchase?.matches('[data-selling-plan]');
      };

      const syncSellingPlans = (card) => {
        if (!form) return;
        const previousPlan = form.querySelector('[data-selling-plan]:checked');
        const preferSubscription = Boolean(previousPlan);
        const matchingPlans = [];

        sellingPlanOptions.forEach((label) => {
          const matchesVariant = label.dataset.variantId === card.dataset.variantId;
          const input = label.querySelector('[data-selling-plan]');
          label.hidden = !matchesVariant;
          if (input) {
            input.disabled = !matchesVariant;
            if (matchesVariant) matchingPlans.push(input);
          }
        });

        const requiresPlan = card.dataset.requiresSellingPlan === 'true';
        if (oneTimeOption) oneTimeOption.hidden = requiresPlan;
        if (oneTimePurchase) {
          oneTimePurchase.disabled = requiresPlan;
          oneTimePurchase.dataset.price = card.dataset.price || '';
          oneTimePurchase.dataset.compare = card.dataset.compare || '';
        }

        if (requiresPlan || preferSubscription) {
          const nextPlan = matchingPlans.find((input) => input.value === previousPlan?.value) || matchingPlans[0];
          if (nextPlan) {
            nextPlan.checked = true;
          } else if (!requiresPlan && oneTimePurchase) {
            oneTimePurchase.checked = true;
          }
        } else if (oneTimePurchase) {
          oneTimePurchase.checked = true;
        }

        updatePurchasePrice();
      };

      const galleryReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const isMobileSlider = () => Boolean(galleryStage?.classList.contains('is-mobile-slider'));
      const nearestMediaIndex = () => {
        if (!galleryStage || !mediaItems.length) return 0;
        return mediaItems.reduce((closest, item, index) => (
          Math.abs(item.offsetLeft - galleryStage.scrollLeft) < Math.abs(mediaItems[closest].offsetLeft - galleryStage.scrollLeft)
            ? index
            : closest
        ), 0);
      };

      const updateMediaState = (index) => {
        if (!mediaItems.length) return;
        currentMediaIndex = Math.max(0, Math.min(index, mediaItems.length - 1));
        mediaItems.forEach((item, index) => {
          item.hidden = isMobileSlider() ? false : index !== currentMediaIndex;
          if (isMobileSlider()) {
            item.setAttribute('aria-hidden', String(index !== currentMediaIndex));
          } else {
            item.removeAttribute('aria-hidden');
          }
          if (index !== currentMediaIndex) item.querySelectorAll('video').forEach((video) => video.pause());
        });
        thumbnails.forEach((thumbnail) => thumbnail.setAttribute('aria-current', String(thumbnail.dataset.galleryThumbnail === mediaItems[currentMediaIndex]?.dataset.productMedia)));
        if (counter) counter.textContent = `${currentMediaIndex + 1} / ${mediaItems.length}`;
      };

      const scrollToMedia = (index, behavior = galleryReducedMotion.matches ? 'auto' : 'smooth') => {
        if (!galleryStage || !isMobileSlider() || !mediaItems[index]) return;
        galleryStage.scrollTo({ left: mediaItems[index].offsetLeft, behavior });
      };

      const showMedia = (mediaId, behavior) => {
        if (!mediaItems.length) return;
        let nextIndex = mediaItems.findIndex((item) => item.dataset.productMedia === String(mediaId));
        if (nextIndex < 0) nextIndex = currentMediaIndex;
        updateMediaState(nextIndex);
        scrollToMedia(nextIndex, behavior);
      };

      const stepMedia = (direction) => {
        if (mediaItems.length < 2) return;
        const nextIndex = (currentMediaIndex + direction + mediaItems.length) % mediaItems.length;
        showMedia(mediaItems[nextIndex]?.dataset.productMedia);
      };

      thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', () => showMedia(thumbnail.dataset.galleryThumbnail)));
      root.querySelector('[data-gallery-previous]')?.addEventListener('click', () => stepMedia(-1));
      root.querySelector('[data-gallery-next]')?.addEventListener('click', () => stepMedia(1));

      if (galleryStage && mediaItems.length > 1) {
        let dragPointerId = null;
        let dragStartX = 0;
        let dragStartScrollLeft = 0;
        let dragMoved = false;
        let galleryScrollFrame = 0;

        galleryStage.addEventListener('dragstart', (event) => {
          if (mobileGallery.matches && event.target.closest('.product-gallery__image')) event.preventDefault();
        });

        galleryStage.addEventListener('pointerdown', (event) => {
          if (
            !mobileGallery.matches
            || !event.isPrimary
            || event.pointerType !== 'mouse'
            || event.button !== 0
            || !event.target.closest('.product-gallery__image')
          ) return;

          dragPointerId = event.pointerId;
          dragStartX = event.clientX;
          dragStartScrollLeft = galleryStage.scrollLeft;
          dragMoved = false;
          galleryStage.setPointerCapture(event.pointerId);
          galleryStage.classList.add('is-dragging');
        });

        galleryStage.addEventListener('pointermove', (event) => {
          if (event.pointerId !== dragPointerId) return;
          const distance = event.clientX - dragStartX;
          if (Math.abs(distance) > 4) dragMoved = true;
          galleryStage.scrollLeft = dragStartScrollLeft - distance;
        });

        const finishDrag = (event) => {
          if (event.pointerId !== dragPointerId) return;
          if (galleryStage.hasPointerCapture(event.pointerId)) galleryStage.releasePointerCapture(event.pointerId);
          dragPointerId = null;
          galleryStage.classList.remove('is-dragging');
          const nextIndex = nearestMediaIndex();
          updateMediaState(nextIndex);
          if (dragMoved) scrollToMedia(nextIndex);
        };

        galleryStage.addEventListener('pointerup', finishDrag);
        galleryStage.addEventListener('pointercancel', finishDrag);
        galleryStage.addEventListener('lostpointercapture', (event) => {
          if (event.pointerId !== dragPointerId) return;
          dragPointerId = null;
          galleryStage.classList.remove('is-dragging');
          const nextIndex = nearestMediaIndex();
          updateMediaState(nextIndex);
          if (dragMoved) scrollToMedia(nextIndex);
        });

        galleryStage.addEventListener('scroll', () => {
          if (!isMobileSlider() || galleryScrollFrame) return;
          galleryScrollFrame = requestAnimationFrame(() => {
            galleryScrollFrame = 0;
            updateMediaState(nearestMediaIndex());
          });
        }, { passive: true });

        const syncGalleryMode = () => {
          galleryStage.classList.toggle('is-mobile-slider', mobileGallery.matches);
          updateMediaState(currentMediaIndex);
          if (mobileGallery.matches) {
            requestAnimationFrame(() => scrollToMedia(currentMediaIndex, 'auto'));
          } else {
            galleryStage.scrollLeft = 0;
          }
        };

        syncGalleryMode();
        mobileGallery.addEventListener('change', syncGalleryMode);
        if ('ResizeObserver' in window) {
          new ResizeObserver(() => {
            if (isMobileSlider()) scrollToMedia(currentMediaIndex, 'auto');
          }).observe(galleryStage);
        }
      }

      root.querySelectorAll('[data-customer-video]').forEach((card) => {
        const video = card.querySelector('video');
        const toggle = card.querySelector('[data-customer-video-toggle]');
        if (!video || !toggle) return;
        toggle.addEventListener('click', async () => {
          root.querySelectorAll('[data-customer-video] video').forEach((otherVideo) => {
            if (otherVideo !== video) otherVideo.pause();
          });
          if (video.paused) {
            try {
              await video.play();
            } catch (error) {
              return;
            }
          } else {
            video.pause();
          }
        });
        video.addEventListener('play', () => {
          video.controls = true;
          card.classList.add('is-playing');
        });
        video.addEventListener('pause', () => {
          video.controls = false;
          card.classList.remove('is-playing');
        });
      });

      const accordions = [...root.querySelectorAll('.main-product__accordions details')];
      const accordionDuration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300;

      const finishAccordionAnimation = (accordion, animation, expanded) => {
        if (accordion._accordionAnimation !== animation) return;
        accordion._accordionAnimation = null;
        accordion.style.removeProperty('height');
        accordion.style.removeProperty('overflow');
        accordion.classList.remove('is-animating', 'is-closing');
        accordion.classList.toggle('is-expanded', expanded);
        if (!expanded) accordion.removeAttribute('open');
      };

      const closeAccordion = (accordion) => {
        if (!accordion.open) return;
        accordion._accordionAnimation?.cancel();
        accordion._accordionAnimation = null;
        const startHeight = accordion.offsetHeight;
        const endHeight = accordion.querySelector('summary')?.offsetHeight || 0;
        accordion.style.height = `${startHeight}px`;
        accordion.style.overflow = 'hidden';
        accordion.classList.add('is-animating', 'is-closing');
        accordion.classList.remove('is-expanded');

        if (accordionDuration === 0) {
          finishAccordionAnimation(accordion, null, false);
          return;
        }

        const animation = accordion.animate(
          { height: [`${startHeight}px`, `${endHeight}px`] },
          { duration: accordionDuration, easing: 'cubic-bezier(0.33, 1, 0.68, 1)' }
        );
        accordion._accordionAnimation = animation;
        animation.onfinish = () => finishAccordionAnimation(accordion, animation, false);
      };

      const openAccordion = (accordion) => {
        accordions.forEach((otherAccordion) => {
          if (otherAccordion !== accordion && otherAccordion.open) closeAccordion(otherAccordion);
        });

        accordion._accordionAnimation?.cancel();
        accordion._accordionAnimation = null;
        const startHeight = accordion.offsetHeight;
        accordion.style.height = `${startHeight}px`;
        accordion.style.overflow = 'hidden';
        accordion.setAttribute('open', '');
        const endHeight = accordion.scrollHeight;
        accordion.classList.remove('is-closing');
        accordion.classList.add('is-animating');

        if (accordionDuration === 0) {
          finishAccordionAnimation(accordion, null, true);
          return;
        }

        window.requestAnimationFrame(() => {
          accordion.classList.add('is-expanded');
          const animation = accordion.animate(
            { height: [`${startHeight}px`, `${endHeight}px`] },
            { duration: accordionDuration, easing: 'cubic-bezier(0.33, 1, 0.68, 1)' }
          );
          accordion._accordionAnimation = animation;
          animation.onfinish = () => finishAccordionAnimation(accordion, animation, true);
        });
      };

      accordions.forEach((accordion) => {
        if (accordion.open) accordion.classList.add('is-expanded');
        accordion.querySelector('summary')?.addEventListener('click', (event) => {
          event.preventDefault();
          if (accordion.classList.contains('is-closing')) {
            openAccordion(accordion);
          } else if (accordion.classList.contains('is-expanded')) {
            closeAccordion(accordion);
          } else {
            openAccordion(accordion);
          }
        });
      });

      form?.querySelectorAll('input[name="selling_plan"]').forEach((option) => {
        option.addEventListener('change', updatePurchasePrice);
      });

      variantCards.forEach((card) => {
        card.querySelector('[data-variant-radio]')?.addEventListener('change', () => {
          const available = card.dataset.available === 'true';
          if (soldOutBadge) soldOutBadge.classList.toggle('is-hidden', available);
          if (addButton) addButton.disabled = !available;
          if (addText) addText.textContent = available ? strings.addToCart : strings.soldOut;
          syncSellingPlans(card);
          if (card.dataset.mediaId) showMedia(card.dataset.mediaId);
          const url = new URL(root.dataset.productUrl, window.location.origin);
          url.searchParams.set('variant', card.dataset.variantId);
          window.history.replaceState({}, '', `${url.pathname}${url.search}`);
        });
      });

      const selectedVariantCard = variantCards.find((card) => card.querySelector('[data-variant-radio]')?.checked);
      if (selectedVariantCard) syncSellingPlans(selectedVariantCard);

      if (!form || !window.fetch || !window.FormData) return;
      form.addEventListener('submit', async (event) => {
        if (event.defaultPrevented) return;
        if (kachingConvergenceRequired && !isKachingSelectionConverged()) {
          event.preventDefault();
          setKachingSubmitConvergence(false);
          queueKachingSync();
          if (status) status.textContent = 'Your offer selection is still loading. Please try again.';
          return;
        }
        if (addButton?.disabled) return;
        event.preventDefault();
        const directCheckout = form.dataset.thalaDirectCheckout === 'true';
        delete form.dataset.thalaDirectCheckout;
        addButton?.classList.add('is-loading');
        if (addButton) addButton.disabled = true;
        if (status) status.textContent = strings.adding;
        const formData = new FormData(form);
        if (formData.get('selling_plan') === '') formData.delete('selling_plan');
        try {
          const addUrl = new URL(form.action, window.location.origin);
          if (!addUrl.pathname.endsWith('.js')) addUrl.pathname = `${addUrl.pathname}.js`;
          const response = await fetch(addUrl.toString(), {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.description || payload.message || strings.addError);
          const rootUrl = window.Shopify?.routes?.root || '/';
          const cartResponse = await fetch(`${rootUrl}cart.js`, { headers: { Accept: 'application/json' } });
          const cart = cartResponse.ok ? await cartResponse.json() : null;
          if (cart) {
            document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
            document.querySelectorAll('[data-cart-link]').forEach((node) => {
              node.setAttribute('aria-label', strings.cartLabelTemplate.replace('__COUNT__', String(cart.item_count)));
            });
          }
          if (status) status.textContent = strings.added;
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, item: payload } }));
          if (directCheckout) {
            const checkoutUrl = new URL(`${rootUrl}checkout`, window.location.origin);
            window.location.assign(checkoutUrl.toString());
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:open', { detail: { cart, item: payload } }));
        } catch (error) {
          if (status) status.textContent = error.message;
          if (directCheckout) {
            kachingCheckoutPending = false;
            document.dispatchEvent(new CustomEvent('thala:kaching:checkout-error', {
              detail: { message: error.message }
            }));
          }
        } finally {
          addButton?.classList.remove('is-loading');
          const activeCard = root.querySelector('[data-variant-radio]:checked')?.closest('[data-variant-card]');
          if (addButton) {
            const selectionBlocked = kachingConvergenceRequired && !isKachingSelectionConverged();
            addButton.disabled = selectionBlocked || (activeCard ? activeCard.dataset.available !== 'true' : false);
          }
        }
      });
    };

    document.querySelectorAll('[data-main-product]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-main-product]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (() => {
    const load = async (section) => {
      if (!section || section.dataset.loaded === 'true' || section.querySelector('.product-recommendations__inner')) return;
      section.dataset.loaded = 'true';
      try {
        const response = await fetch(section.dataset.url);
        if (!response.ok) return;
        const html = document.createElement('div');
        html.innerHTML = await response.text();
        const replacement = html.querySelector(`#${CSS.escape(section.id)}`);
        if (replacement?.innerHTML.trim()) section.innerHTML = replacement.innerHTML;
      } catch (error) {
        section.dataset.loaded = 'false';
      }
    };

    document.querySelectorAll('[data-product-recommendations]').forEach(load);
    document.addEventListener('shopify:section:load', (event) => load(event.target.querySelector('[data-product-recommendations]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reasons-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rs-reasons]').forEach((section) => {
    const track = section.querySelector('[data-rs-reasons-track]');
    const cards = Array.from(section.querySelectorAll('[data-reason-card]'));
    const dots = Array.from(section.querySelectorAll('[data-rs-reason-dot]'));
    const previous = section.querySelector('[data-rs-reasons-prev]');
    const next = section.querySelector('[data-rs-reasons-next]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let activeIndex = 0;
    let scrollFrame = 0;
    if (!cards.length) return;

    const maximumIndex = () => {
      const visibleCards = window.matchMedia('(min-width: 768px)').matches ? 3 : 1;
      return Math.max(0, cards.length - visibleCards);
    };

    const dotTargets = () => {
      const maximum = maximumIndex();
      return [0, Math.round(maximum / 2), maximum];
    };

    const updateDots = () => {
      const targets = dotTargets();
      const activeDot = targets.reduce((closest, target, index) => (
        Math.abs(target - activeIndex) < Math.abs(targets[closest] - activeIndex) ? index : closest
      ), 0);
      dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', dotIndex === activeDot ? 'true' : 'false'));
    };

    const show = (index) => {
      const maximum = maximumIndex();
      activeIndex = index < 0 ? maximum : index > maximum ? 0 : index;
      const target = cards[activeIndex];
      track.scrollTo({
        left: target.offsetLeft - track.offsetLeft,
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
      updateDots();
    };

    previous.addEventListener('click', () => show(activeIndex - 1));
    next.addEventListener('click', () => show(activeIndex + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => show(dotTargets()[index] || 0)));
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') show(activeIndex - 1);
      if (event.key === 'ArrowRight') show(activeIndex + 1);
    });
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(() => {
        const trackLeft = track.getBoundingClientRect().left;
        activeIndex = cards.reduce((closest, card, index) => (
          Math.abs(card.getBoundingClientRect().left - trackLeft) < Math.abs(cards[closest].getBoundingClientRect().left - trackLeft)
            ? index
            : closest
        ), 0);
        activeIndex = Math.min(activeIndex, maximumIndex());
        updateDots();
      });
    }, { passive: true });
    window.addEventListener('resize', () => {
      activeIndex = Math.min(activeIndex, maximumIndex());
      updateDots();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["research-benefits"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (section) => {
      if (!section || section.dataset.researchInitialized === 'true') return;
      section.dataset.researchInitialized = 'true';
      const cards = [...section.querySelectorAll('details')];
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const duration = reducedMotion ? 0 : 500;

      const verticalPadding = (element) => {
        const styles = window.getComputedStyle(element);
        return parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom);
      };

      const closedHeight = (card) => {
        const summary = card.querySelector('summary');
        const main = card.querySelector('.rs-research__summary-main');
        const toggle = card.querySelector('.rs-research__toggle');
        if (!summary || !main || !toggle) return 0;
        return Math.ceil(Math.max(main.scrollHeight, toggle.offsetHeight) + verticalPadding(summary));
      };

      const openHeight = (card) => {
        const answer = card.querySelector('.rs-research__answer');
        const answerInner = card.querySelector('.rs-research__answer-inner');
        const minimum = closedHeight(card);
        if (!answer || !answerInner) return minimum;
        return Math.ceil(Math.max(minimum, answerInner.scrollHeight + verticalPadding(answer)));
      };

      const measure = (card, expanded = card.classList.contains('is-open')) => {
        const height = expanded ? openHeight(card) : closedHeight(card);
        if (height > 0) card.style.setProperty('--rs-research-card-height', `${height}px`);
      };

      const close = (card) => {
        window.clearTimeout(Number(card.dataset.closeTimer || 0));
        card.classList.remove('is-open');
        const timer = window.setTimeout(() => {
          card.removeAttribute('open');
          measure(card, false);
          card.dataset.closeTimer = '';
        }, duration);
        card.dataset.closeTimer = String(timer);
      };

      const open = (card) => {
        cards.forEach((otherCard) => {
          if (otherCard !== card && otherCard.open) close(otherCard);
        });
        window.clearTimeout(Number(card.dataset.closeTimer || 0));
        card.setAttribute('open', '');
        measure(card, true);
        requestAnimationFrame(() => {
          card.classList.add('is-open');
          measure(card, true);
        });
      };

      cards.forEach((card) => {
        measure(card, card.classList.contains('is-open'));
        card.querySelector('summary')?.addEventListener('click', (event) => {
          event.preventDefault();
          if (card.classList.contains('is-open')) close(card);
          else open(card);
        });
        card.querySelectorAll('img').forEach((image) => {
          if (!image.complete) image.addEventListener('load', () => measure(card), { once: true });
        });
      });

      let resizeFrame = 0;
      const remeasure = () => {
        window.cancelAnimationFrame(resizeFrame);
        resizeFrame = window.requestAnimationFrame(() => cards.forEach((card) => measure(card)));
      };
      window.addEventListener('resize', remeasure);
      document.fonts?.ready.then(remeasure);
    };

    document.querySelectorAll('[data-rs-research]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-rs-research]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scratch-popup"]) return;
  try {
    
  (() => {
    const STORAGE_PREFIX = 'resilia-scratch:';
    const SESSION_SUFFIX = ':shown';
    const DAY = 86400000;

    const safeStorage = {
      read(storage, key) {
        try {
          return storage.getItem(key);
        } catch (error) {
          return null;
        }
      },
      write(storage, key, value) {
        try {
          storage.setItem(key, value);
        } catch (error) {
          return;
        }
      },
    };

    const setPhase = (dialog, state) => {
      dialog.dataset.state = state;
      dialog.querySelectorAll('[data-scratch-phase]').forEach((phase) => {
        phase.hidden = phase.dataset.scratchPhase !== (state === 'revealed' ? 'scratch' : state);
      });
      const activePhase = dialog.querySelector(`[data-scratch-phase="${state === 'revealed' ? 'scratch' : state}"]`);
      const activeHeading = activePhase?.querySelector('[data-scratch-heading]');
      const activeDescription = activePhase?.querySelector('[data-scratch-description]');
      if (activeHeading?.id) dialog.setAttribute('aria-labelledby', activeHeading.id);
      if (activeDescription?.id) {
        dialog.setAttribute('aria-describedby', activeDescription.id);
      } else {
        dialog.removeAttribute('aria-describedby');
      }
      const panel = dialog.querySelector('.scratch-popup__panel');
      if (panel) panel.scrollTop = 0;
    };

    const initializeScratchSurface = (dialog) => {
      const canvas = dialog.querySelector('[data-scratch-canvas]');
      const card = dialog.querySelector('[data-scratch-card]');
      const prize = dialog.querySelector('[data-scratch-prize]');
      const live = dialog.querySelector('[data-scratch-live]');
      if (!canvas || !card || !prize) return { reveal() {} };

      const context = canvas.getContext('2d', { willReadFrequently: true });
      const coverColor = canvas.dataset.coverColor || '#d4b252';
      const coverTextColor = canvas.dataset.coverTextColor || '#fff7db';
      const coverLabel = canvas.dataset.coverLabel || '';
      const coverImageUrl = dialog.dataset.coverImage || '';
      const threshold = Math.max(0.2, Math.min(0.85, Number(dialog.dataset.revealThreshold) / 100 || 0.45));
      const paths = [];
      let activePath = null;
      let revealed = false;
      let coverageFrame = null;
      let lastCoverageRead = 0;
      let dpr = 1;
      let coverImage = null;

      const drawCover = () => {
        const rect = card.getBoundingClientRect();
        if (!rect.width || !rect.height || revealed) return;

        dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.round(rect.width * dpr);
        canvas.height = Math.round(rect.height * dpr);
        canvas.style.width = `${rect.width}px`;
        canvas.style.height = `${rect.height}px`;
        context.setTransform(dpr, 0, 0, dpr, 0, 0);
        context.globalCompositeOperation = 'source-over';
        context.globalAlpha = 1;
        context.fillStyle = coverColor;
        context.fillRect(0, 0, rect.width, rect.height);

        if (coverImage) {
          const scale = Math.max(rect.width / coverImage.naturalWidth, rect.height / coverImage.naturalHeight);
          const imageWidth = coverImage.naturalWidth * scale;
          const imageHeight = coverImage.naturalHeight * scale;
          context.drawImage(
            coverImage,
            (rect.width - imageWidth) / 2,
            (rect.height - imageHeight) / 2,
            imageWidth,
            imageHeight
          );
        }

        context.fillStyle = coverTextColor;
        context.globalAlpha = 0.82;
        context.font = `700 ${Math.max(22, Math.min(42, rect.width * 0.085))}px Satoshi, sans-serif`;
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.fillText(coverLabel, rect.width / 2, rect.height / 2);
        context.globalAlpha = 1;

        paths.forEach((path) => erasePath(path, rect));
      };

      const normalizedPoint = (event) => {
        const rect = canvas.getBoundingClientRect();
        return {
          x: Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width)),
          y: Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height)),
        };
      };

      const erasePath = (path, rect = canvas.getBoundingClientRect()) => {
        if (!path.length) return;
        context.save();
        context.globalCompositeOperation = 'destination-out';
        context.lineCap = 'round';
        context.lineJoin = 'round';
        context.lineWidth = Math.max(34, Math.min(rect.width, rect.height) * 0.145);
        context.beginPath();
        context.moveTo(path[0].x * rect.width, path[0].y * rect.height);
        path.slice(1).forEach((point) => context.lineTo(point.x * rect.width, point.y * rect.height));
        if (path.length === 1) {
          context.lineTo(path[0].x * rect.width + 0.01, path[0].y * rect.height + 0.01);
        }
        context.stroke();
        context.restore();
      };

      const reveal = () => {
        if (revealed) return;
        revealed = true;
        if (coverageFrame) window.cancelAnimationFrame(coverageFrame);
        canvas.setAttribute('aria-disabled', 'true');
        canvas.tabIndex = -1;
        prize.setAttribute('aria-hidden', 'false');
        setPhase(dialog, 'revealed');
        if (live) live.textContent = dialog.dataset.prizeRevealedLabel || '';
      };

      const measureCoverage = () => {
        coverageFrame = null;
        if (revealed || !canvas.width || !canvas.height) return;
        try {
          const pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
          const sample = Math.max(8, Math.round(12 * dpr));
          let erased = 0;
          let total = 0;
          for (let y = 0; y < canvas.height; y += sample) {
            for (let x = 0; x < canvas.width; x += sample) {
              total += 1;
              if (pixels[(y * canvas.width + x) * 4 + 3] < 24) erased += 1;
            }
          }
          if (total && erased / total >= threshold) reveal();
        } catch (error) {
          return;
        }
      };

      const requestCoverageCheck = (force = false) => {
        const now = Date.now();
        if (!force && now - lastCoverageRead < 120) return;
        lastCoverageRead = now;
        if (!coverageFrame) coverageFrame = window.requestAnimationFrame(measureCoverage);
      };

      const appendPoints = (event) => {
        const coalescedPoints = typeof event.getCoalescedEvents === 'function' ? event.getCoalescedEvents() : [];
        const points = coalescedPoints.length ? coalescedPoints : [event];
        points.forEach((pointEvent) => activePath.push(normalizedPoint(pointEvent)));
        erasePath(activePath.slice(-Math.max(2, points.length + 1)));
      };

      canvas.addEventListener('pointerdown', (event) => {
        if (revealed) return;
        event.preventDefault();
        canvas.setPointerCapture(event.pointerId);
        activePath = [normalizedPoint(event)];
        paths.push(activePath);
        erasePath(activePath);
        requestCoverageCheck(true);
      });

      canvas.addEventListener('pointermove', (event) => {
        if (!activePath || revealed) return;
        event.preventDefault();
        appendPoints(event);
        requestCoverageCheck();
      });

      const finishStroke = (event) => {
        if (!activePath) return;
        if (event && canvas.hasPointerCapture(event.pointerId)) canvas.releasePointerCapture(event.pointerId);
        activePath = null;
        requestCoverageCheck(true);
      };

      canvas.addEventListener('pointerup', finishStroke);
      canvas.addEventListener('pointercancel', finishStroke);
      canvas.addEventListener('lostpointercapture', () => {
        activePath = null;
      });

      canvas.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        reveal();
      });

      dialog.querySelector('[data-scratch-reveal]')?.addEventListener('click', reveal);

      const observer = new ResizeObserver(() => drawCover());
      observer.observe(card);
      drawCover();
      if (coverImageUrl) {
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.decoding = 'async';
        image.addEventListener('load', () => {
          coverImage = image;
          drawCover();
        });
        image.src = coverImageUrl;
      }

      return { reveal };
    };

    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-scratch-popup]').forEach((dialog) => {
        if (dialog.dataset.scratchInitialized === 'true') return;
        dialog.dataset.scratchInitialized = 'true';

        const campaign = dialog.dataset.campaignKey || 'default';
        const storageKey = `${STORAGE_PREFIX}${campaign}`;
        const sessionKey = `${storageKey}${SESSION_SUFFIX}`;
        const designMode = dialog.dataset.designMode === 'true';
        const localPreview = window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost';
        const previewState = localPreview ? new URLSearchParams(window.location.search).get('scratch_preview') : null;
        const claimMarker = new URLSearchParams(window.location.search).get('scratch_claim');
        const submittedFromScratchPopup = claimMarker === campaign;
        const successMarker = submittedFromScratchPopup ? dialog.querySelector('[data-scratch-form-success]') : null;
        const errorMarker = submittedFromScratchPopup ? dialog.querySelector('[data-scratch-form-error]') : null;
        const forceOpen = Boolean(successMarker || errorMarker || previewState);
        const previousFocus = { element: null };
        let closeStatus = 'dismissed';

        const scratchSurface = initializeScratchSurface(dialog);
        const initialState = successMarker
          ? 'success'
          : errorMarker
            ? 'email'
            : ['revealed', 'email', 'success'].includes(previewState)
              ? previewState
              : 'scratch';
        if (initialState === 'revealed') {
          scratchSurface.reveal();
        } else {
          setPhase(dialog, initialState);
        }

        const remember = (status) => {
          if (designMode) return;
          const days = status === 'claimed' ? Number(dialog.dataset.claimedDays) || 180 : Number(dialog.dataset.dismissDays) || 30;
          safeStorage.write(window.localStorage, storageKey, JSON.stringify({ status, until: Date.now() + days * DAY }));
        };

        const open = () => {
          if (dialog.open || typeof dialog.showModal !== 'function') return;
          previousFocus.element = document.activeElement;
          dialog.showModal();
          document.body.classList.add('scratch-popup-open');
          safeStorage.write(window.sessionStorage, sessionKey, 'true');
          window.requestAnimationFrame(() => {
            const focusTarget = dialog.dataset.state === 'email'
              ? dialog.querySelector('[data-scratch-form-error-message], [data-scratch-email]')
              : dialog.dataset.state === 'success'
                ? dialog.querySelector('.scratch-popup__success-heading')
                : dialog;
            if (focusTarget) {
              if (!focusTarget.hasAttribute('tabindex') && !focusTarget.matches('input, button, a')) focusTarget.tabIndex = -1;
              focusTarget.focus({ preventScroll: true });
            }
          });
        };
        dialog.addEventListener('scratch-popup:open', open);

        if (successMarker) {
          closeStatus = 'claimed';
          remember('claimed');
        }

        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) {
            closeStatus = dialog.dataset.state === 'success' ? 'claimed' : 'dismissed';
            dialog.close();
            return;
          }

          if (event.target.closest('[data-scratch-dismiss]')) {
            closeStatus = dialog.dataset.state === 'success' ? 'claimed' : 'dismissed';
          }

          if (event.target.closest('[data-scratch-claim]')) {
            setPhase(dialog, 'email');
            window.requestAnimationFrame(() => dialog.querySelector('[data-scratch-email]')?.focus({ preventScroll: true }));
          }

          if (event.target.closest('[data-scratch-back]')) {
            setPhase(dialog, 'revealed');
            window.requestAnimationFrame(() => dialog.querySelector('[data-scratch-claim]')?.focus({ preventScroll: true }));
          }

          const copyButton = event.target.closest('[data-scratch-copy-code]');
          if (copyButton) {
            const code = dialog.querySelector('[data-scratch-code]')?.textContent.trim();
            if (!code || !navigator.clipboard) return;
            navigator.clipboard.writeText(code).then(() => {
              copyButton.textContent = dialog.dataset.copiedLabel || copyButton.textContent;
            });
          }
        });

        dialog.addEventListener('cancel', () => {
          closeStatus = dialog.dataset.state === 'success' ? 'claimed' : 'dismissed';
        });

        dialog.addEventListener('close', () => {
          document.body.classList.remove('scratch-popup-open');
          remember(closeStatus);
          if (previousFocus.element instanceof HTMLElement) previousFocus.element.focus({ preventScroll: true });
        });

        if (designMode || forceOpen) {
          window.setTimeout(open, forceOpen ? 0 : 120);
          return;
        }

        const stored = safeStorage.read(window.localStorage, storageKey);
        const shownThisSession = safeStorage.read(window.sessionStorage, sessionKey) === 'true';
        let suppressed = shownThisSession;
        if (stored) {
          try {
            const parsed = JSON.parse(stored);
            suppressed = suppressed || Number(parsed.until) > Date.now();
          } catch (error) {
            suppressed = suppressed || false;
          }
        }

        if (!suppressed) window.setTimeout(open, Math.max(0, Number(dialog.dataset.delay) || 0));
      });
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:select', (event) => {
      const dialog = event.target.querySelector('[data-scratch-popup]');
      if (dialog && !dialog.open) dialog.dispatchEvent(new CustomEvent('scratch-popup:open'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stock-up-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const fallbackGifts = [
      'Thala Glow Beauty Oil',
      'Three personalized GLP-1, diet and workout guides',
      'Free shipping'
    ];

    const cleanGiftLabel = (label) => String(label || '')
      .replace(/^\s*\+\s*/i, '')
      .replace(/\s+/g, ' ')
      .trim();

    const initialize = (section) => {
      if (!section || section.dataset.stockInitialized === 'true') return;
      section.dataset.stockInitialized = 'true';

      const plansContainer = section.querySelector('[data-stock-plans]');
      const planTemplate = section.querySelector('[data-stock-plan-template]');
      const priceRow = section.querySelector('[data-stock-price-row]');
      const price = section.querySelector('[data-stock-price]');
      const compare = section.querySelector('[data-stock-compare]');
      const giftsList = section.querySelector('[data-stock-gifts]');
      const checkoutButton = section.querySelector('[data-stock-checkout]');
      const status = section.querySelector('[data-stock-status]');
      let selectedId = '';
      let latestState = null;
      let checkoutPending = false;

      if (!plansContainer || !planTemplate || !checkoutButton) return;
      checkoutButton.dataset.defaultLabel = checkoutButton.textContent.trim();

      const renderGifts = (gifts) => {
        if (!giftsList) return;
        const labels = [...new Set((gifts || []).map((gift) => cleanGiftLabel(gift.label)).filter(Boolean))];
        const visibleLabels = labels.length ? labels : fallbackGifts;
        giftsList.replaceChildren(...visibleLabels.map((label) => {
          const item = document.createElement('li');
          item.textContent = label;
          return item;
        }));
      };

      const renderState = (state) => {
        if (!state?.ready || !Array.isArray(state.plans) || !state.plans.length) return;
        latestState = state;
        selectedId = state.selectedId || state.plans[0].id;
        const selectedPlan = state.plans.find((plan) => plan.id === selectedId) || state.plans[0];
        selectedId = selectedPlan.id;

        if (priceRow) priceRow.hidden = false;
        if (price) price.textContent = selectedPlan.price || '';
        if (compare) {
          const showCompare = selectedPlan.compareCents > selectedPlan.totalCents;
          compare.textContent = showCompare ? selectedPlan.comparePrice : '';
          compare.hidden = !showCompare;
        }
        renderGifts(selectedPlan.gifts);

        plansContainer.replaceChildren();
        plansContainer.setAttribute('aria-busy', 'false');
        state.plans.forEach((plan) => {
          const fragment = planTemplate.content.cloneNode(true);
          const button = fragment.querySelector('[data-stock-plan]');
          const badge = fragment.querySelector('[data-stock-plan-badge]');
          const planCompare = fragment.querySelector('[data-stock-plan-compare]');
          const planSave = fragment.querySelector('[data-stock-plan-save]');

          button.dataset.stockPlanId = plan.id;
          button.setAttribute('aria-pressed', String(plan.id === selectedId));
          button.querySelector('[data-stock-plan-title]').textContent = plan.title;
          button.querySelector('[data-stock-plan-quantity]').textContent = `×${plan.quantity}`;
          button.querySelector('[data-stock-plan-price]').textContent = plan.price;

          const showCompare = plan.compareCents > plan.totalCents;
          planCompare.textContent = showCompare ? plan.comparePrice : '';
          planCompare.hidden = !showCompare;
          planSave.textContent = plan.saveCents > 0 ? `Save ${plan.save}` : '';
          planSave.hidden = plan.saveCents <= 0;
          badge.textContent = plan.badge || '';
          badge.hidden = !plan.badge;

          button.addEventListener('click', () => {
            const api = window.ThalaKachingBundles;
            if (!api?.selectPlan?.(plan.id)) {
              if (status) status.textContent = 'Bundle options are still loading. Please try again.';
              return;
            }
            renderState({ ...latestState, selectedId: plan.id });
            if (status) status.textContent = '';
          });
          plansContainer.appendChild(fragment);
        });

        checkoutButton.disabled = checkoutPending;
      };

      const hydrateFromApi = () => {
        const state = window.ThalaKachingBundles?.getState?.();
        if (state?.ready) renderState(state);
      };

      document.addEventListener('thala:kaching:state', (event) => {
        renderState(event.detail);
      });

      document.addEventListener('thala:kaching:checkout-error', (event) => {
        if (!checkoutPending) return;
        checkoutPending = false;
        checkoutButton.disabled = false;
        checkoutButton.textContent = checkoutButton.dataset.defaultLabel;
        if (status) status.textContent = event.detail?.message || 'Checkout could not open. Please try again.';
      });

      checkoutButton.addEventListener('click', () => {
        const api = window.ThalaKachingBundles;
        if (!selectedId || !api?.checkout?.(selectedId)) {
          if (status) status.textContent = 'Bundle options are still loading. Please try again.';
          return;
        }
        checkoutPending = true;
        checkoutButton.disabled = true;
        checkoutButton.textContent = 'Opening secure checkout...';
        if (status) status.textContent = 'Adding your selected bundle and free gifts.';
      });

      renderGifts([]);
      hydrateFromApi();
    };

    document.querySelectorAll('[data-rs-stock-up]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target.querySelector('[data-rs-stock-up]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (section) => {
      if (!section || section.dataset.storiesInitialized === 'true') return;
      section.dataset.storiesInitialized = 'true';
      const viewport = section.querySelector('.rs-stories__marquee');
      const track = section.querySelector('.rs-stories__marquee-track');
      const original = track?.querySelector('.rs-stories__photo-list:not(.rs-stories__photo-list--duplicate)');
      if (!viewport || !track || !original) return;
      let resizeFrame;

      const prepare = async () => {
        section.classList.remove('is-ready');
        track.querySelectorAll('.rs-stories__photo-list.is-generated').forEach((clone) => clone.remove());
        const distance = original.getBoundingClientRect().width;
        if (!distance) return;
        while (track.scrollWidth < viewport.clientWidth + distance) {
          const clone = original.cloneNode(true);
          clone.classList.add('rs-stories__photo-list--duplicate', 'is-generated');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[data-shopify-editor-block]').forEach((node) => node.removeAttribute('data-shopify-editor-block'));
          track.appendChild(clone);
        }
        track.style.setProperty('--rs-stories-distance', `${distance * -1}px`);
        const originals = [...original.querySelectorAll('img')];
        await Promise.allSettled(originals.map((image) => image.decode ? image.decode() : Promise.resolve()));
        requestAnimationFrame(() => section.classList.add('is-ready'));
      };

      prepare();
      window.addEventListener('resize', () => {
        cancelAnimationFrame(resizeFrame);
        resizeFrame = requestAnimationFrame(prepare);
      }, { passive: true });

      const reviews = section.querySelector('[data-rs-stories-reviews]');
      const reviewCards = [...section.querySelectorAll('.rs-stories__review')];
      const dots = [...section.querySelectorAll('[data-rs-stories-dot]')];
      const previous = section.querySelector('[data-rs-stories-prev]');
      const next = section.querySelector('[data-rs-stories-next]');
      let activeReview = 0;
      let reviewScrollFrame = 0;

      const updateDots = () => {
        dots.forEach((dot, index) => dot.setAttribute('aria-current', index === activeReview ? 'true' : 'false'));
      };

      const showReview = (index) => {
        if (!reviews || !reviewCards.length) return;
        activeReview = index < 0 ? reviewCards.length - 1 : index >= reviewCards.length ? 0 : index;
        reviews.scrollTo({
          left: reviewCards[activeReview].offsetLeft - reviews.offsetLeft,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
        updateDots();
      };

      previous?.addEventListener('click', () => showReview(activeReview - 1));
      next?.addEventListener('click', () => showReview(activeReview + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => showReview(index)));
      reviews?.addEventListener('scroll', () => {
        cancelAnimationFrame(reviewScrollFrame);
        reviewScrollFrame = requestAnimationFrame(() => {
          const reviewsLeft = reviews.getBoundingClientRect().left;
          activeReview = reviewCards.reduce((closest, card, index) => (
            Math.abs(card.getBoundingClientRect().left - reviewsLeft) < Math.abs(reviewCards[closest].getBoundingClientRect().left - reviewsLeft)
              ? index
              : closest
          ), 0);
          updateDots();
        });
      }, { passive: true });
    };

    document.querySelectorAll('[data-rs-stories]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-rs-stories]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rs-video-stories]').forEach((section) => {
    const track = section.querySelector('[data-rs-video-track]');
    const cards = Array.from(section.querySelectorAll('[data-rs-video-card]'));
    const previous = section.querySelector('[data-rs-video-prev]');
    const next = section.querySelector('[data-rs-video-next]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const move = (direction) => {
      const card = cards[0];
      if (!card) return;
      track.scrollBy({ left: card.getBoundingClientRect().width * direction, behavior: reducedMotion ? 'auto' : 'smooth' });
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));

    section.querySelectorAll('[data-rs-video-play]').forEach((button) => {
      const video = button.closest('.rs-video-stories__media').querySelector('video');
      if (!video) return;

      video.addEventListener('play', () => {
        video.controls = true;
        button.hidden = true;
      });
      video.addEventListener('pause', () => {
        video.controls = false;
        button.hidden = false;
      });
      video.addEventListener('ended', () => {
        video.controls = false;
        button.hidden = false;
      });

      button.addEventListener('click', async () => {
        section.querySelectorAll('video').forEach((otherVideo) => {
          if (otherVideo !== video) otherVideo.pause();
        });
        if (video.paused) {
          try {
            await video.play();
          } catch (error) {
            button.hidden = false;
          }
        } else {
          video.pause();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellness-timeline"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (section) => {
      if (!section || section.dataset.timelineInitialized === 'true') return;
      section.dataset.timelineInitialized = 'true';
      const stages = [...section.querySelectorAll('[data-rs-timeline-stage]')];
      let frame;
      const update = () => {
        frame = undefined;
        const threshold = window.innerHeight - 200;
        stages.forEach((stage) => {
          stage.classList.toggle('is-active', stage.getBoundingClientRect().bottom <= threshold);
        });
      };
      const requestUpdate = () => {
        if (frame) return;
        frame = requestAnimationFrame(update);
      };
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
      requestUpdate();
    };

    document.querySelectorAll('[data-rs-timeline]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-rs-timeline]')));
  })();

  } catch(e) { console.error(e); }
})();
})();
